import { useRecoilValue } from "recoil";
import { selectedFormIdState } from "../../storage/formStates";
import { FormDetail } from "../forms/FormDetail";
import { FormList } from "../forms/FormList";
import { AsideLayout } from "../layout/AsideLayout";
import { FormsProvider } from "../providers/FormsProvider";

export function FormListPage() {
  const selectedFormId = useRecoilValue(selectedFormIdState);

  return (
    <>
      <FormsProvider />
      <AsideLayout
        canHide={selectedFormId !== undefined}
        aside={<FormList />}
      >
        {selectedFormId !== undefined && <FormDetail />}
      </AsideLayout>
    </>
  );
}
